import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
// routes
import { RouterLink } from 'src/routes/components';
// components
import { useSettingsContext } from 'src/components/settings';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const theme = useTheme();
  
  const settings = useSettingsContext();
  const isSidebarOpen = settings.themeLayout === 'vertical';

  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        width: 40,
        height: 60,
        display: 'inline-flex',
        ...sx,
      }}
      {...other}
    >
      {/* Sidebar Logo */}
      <Box
  position="absolute"
  top={isSidebarOpen ? -18 : 20}
  left={isSidebarOpen ? 24 : 24}
>        <img
  style={{
    height: isSidebarOpen ? 118 : 40,
  }}          alt="logo"
          src={isSidebarOpen ? '/logo/logo.png' : '/logo/mini-logo.png'}
        />
      </Box>
    </Box>
  );

  if (disabledLink) {
    return logo;

  }

  return (
    <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
